import { Autoplay, EffectFade } from 'swiper/modules';
import Swiper from 'swiper';

export default function initHeader() {
  let lastScrollTop = 0;
  const mainWrapper = document.getElementById('wrapper') as HTMLElement;
  const autohideElement = document.getElementById('header') as HTMLElement;

  function positionHeader() {
    const scrollTop = window.scrollY;
    if (scrollTop < 70) {
      autohideElement.classList.add('scrolled-top');
      autohideElement.classList.remove('scrolled-down', 'scrolled-up');

      mainWrapper.classList.add('scrolled-top');
      mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      autohideElement.classList.remove('scrolled-top', 'scrolled-down');
      autohideElement.classList.add('scrolled-up');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
      mainWrapper.classList.add('scrolled-up');
    } else {
      autohideElement.classList.remove('scrolled-top', 'scrolled-up');
      autohideElement.classList.add('scrolled-down');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
      mainWrapper.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  if (autohideElement && mainWrapper) {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        positionHeader();
      });
      positionHeader();
    });
  }
  Alpine.data('header', () => ({
    hover: false,
    open: false,
    prevDropdownKey: '',
    openDropdownKey: '',
    initTicker() {
      const ticker = this.$el.querySelector('.header-ticker-swiper') as HTMLElement;
      if (ticker) {
        // eslint-disable-next-line no-new
        new Swiper(ticker, {
          modules: [Autoplay, EffectFade],
          effect: 'fade',
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
      }
    },
    toggleMenuSectionOpen() {
      const button = this.$el;
      const { key, parentKey } = button.dataset;
      // toggle current dropdown
      if (key) {
        this.prevDropdownKey = parentKey ?? '';
        this.openDropdownKey = this.openDropdownKey === key ? '' : key;
      }
    },
    isMenuSectionOpen(key: string) {
      return (key !== '' && this.prevDropdownKey === key) || this.openDropdownKey === key;
    },
    backToPreviousSection() {
      this.openDropdownKey = this.prevDropdownKey;
      this.prevDropdownKey = '';
    },
    openDialog() {
      this.open = true;
      document.documentElement.classList.add('nav-active');
      document.body.classList.add('nav-active');
    },
    closeDialog() {
      this.open = false;
      document.documentElement.classList.remove('nav-active');
      document.body.classList.remove('nav-active');
      this.prevDropdownKey = '';
      this.openDropdownKey = '';
    },
    init() {
      this.initTicker();
      const preselected = this.$el.querySelector('.menu-opener.active') as HTMLElement;
      if (preselected) {
        const { key } = preselected.dataset;
        this.openDropdownKey = key ?? '';
      }
      const trustpilotScriptSrc = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      const existingTrustpilotScript = document.getElementById('trustpilot-script');
      if (!existingTrustpilotScript) {
        const script = document.createElement('script');
        script.id = 'trustpilot-script';
        script.src = trustpilotScriptSrc;
        script.defer = true;
        script.async = true;
        document.head.appendChild(script);
      }
    },
  }));
}
